import React from 'react';
import styled from 'styled-components';
import { FloatingPattern } from '../components/common';

const PageContainer = styled.div`
    position: relative;
    min-height: 100vh;
    padding: 100px 2rem 2rem;
    background-color: ${({ theme }) => theme.colors.backgroundDark};
    overflow-x: hidden;
`;

const PageTitle = styled.h1`
    color: ${({ theme }) => theme.colors.primary};
    font-size: 3rem;
    margin-bottom: 2rem;
    text-align: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 2rem;
    }
`;

const ContentContainer = styled.div`
    max-width: 900px;
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.8;
    font-size: 1.1rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 1rem;
    }
`;

const Paragraph = styled.p`
    margin-bottom: 1.5rem;
`;

const Signature = styled.p`
    margin-top: 3rem;
    font-style: italic;
    text-align: right;
`;

export const StoryPage: React.FC = () => {
    return (
        <PageContainer>
            <FloatingPattern />
            <PageTitle>Story</PageTitle>
            <ContentContainer>
                <Paragraph>
                    We here at The Butterscotch Boys began with a simple idea: to create a focused,
                    flexible creative outlet—one designed to support the long-term artistic goals of
                    me, Tyler Vander Maas.
                </Paragraph>
                <Paragraph>
                    With music being my primary art form, it seemed prudent to start by forming a
                    band. Fortunately, this part was quite easy. Some people called it nepotism.
                    Others said I simply stole The All-American Funk Parade. I prefer to think of it
                    as capitalism. And let me tell you—having a little money can save you a lot of
                    hard work.
                </Paragraph>
                <Paragraph>
                    Even with the winds of venture capital at our backs, getting off the ground
                    proved challenging. Our first show was at a 900-seat venue, and we drew a crowd
                    of roughly thirty. But when you truly believe you are better than everyone else,
                    not even the most obvious signs will stop you from pursuing your dreams. So I
                    rallied the troops, and we played a magnificent show—one so inspirational that a
                    young, enterprising audience member applied to join the band.
                </Paragraph>
                <Paragraph>
                    That young man was Ryan Hoger, now my right-hand man and a shining example of
                    what being a Butterscotch Boy is all about: serving my needs.
                </Paragraph>
                <Paragraph>
                    With Ryan on board and the prototype officially tested, it was time to get
                    serious. An album? Completed. A music-video generator? Done. A custom website?
                    No problem. And now, a full-scale video production team.
                </Paragraph>
                <Paragraph>
                    By any reasonable metric, the project has succeeded. Music is being made. Ideas
                    are flowing. And most importantly, the process itself has proven deeply
                    rewarding.
                </Paragraph>
                <Paragraph>
                    Looking ahead, we at The Butterscotch Boys are positioned to continue doing
                    exactly what we were designed to do: provide a consistent, evolving outlet for
                    creative work—one that can grow, adapt, and remain useful to me for years to
                    come.
                </Paragraph>
                <Paragraph>
                    If you would like to use The Butterscotch Boys to meet your entertainment needs,
                    we ask that you first make your needs useful to me. After that, please reach out
                    through the contact page on our website. Thank you!
                </Paragraph>
                <Signature>- Tyler Vander Maas</Signature>
            </ContentContainer>
        </PageContainer>
    );
};
